export const getPaymentFailed = (payment: GQL.IPayment | undefined) => {
  return (
    payment &&
    (['error', 'refused', 'canceled'] as any).includes(payment.status)
  );
};


// WEBPACK FOOTER //
// ./src/helpers/payment/getPaymentFailed.ts